import React from "react";
import About from "./About";
import Brochure from "./Brochure";
import Gallery from "./Gallery";
import BusinessCards from "./BusinessCards";
import Contact from "./Contact";
import Cookies from "./Cookies";

const Home = () => {
    return (
        <main className="d-flex flex-column min-vh-100">
            <About/>
            <Brochure/>
            <Gallery/>
            <BusinessCards/>
            <Contact/>
            <Cookies/>
        </main>
    );
}

export default Home


// WEBPACK FOOTER //
// ./src/components/Home.js